exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.company-image[data-v-4301376b] {\n    border:1px solid #F5B821;\n    background: #fff;\n    width: 150px;\n    height: 150px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    border-radius: 50%;\n}\n#fl_inp[data-v-4301376b] {\n    display:none;\n}\n.fl_upld label[data-v-4301376b] {\n    cursor: pointer;\n    padding: 10px 25px;\n    color: #F5B821;\n    text-align: center;\n}\n\n", ""]);

// exports
